import Address from '@/models/Customers/Addresses/Address';

export default (value: Address) => {
    if (value != null) {
        return [value.addressLine1,
            value.addressLine2,
            value.city,
            value.postCode,
            value.country]
            .filter(Boolean).join(", ");
    }
}